import { render } from "./PublicOptimizationDetail.vue?vue&type=template&id=1ec9fc4f&scoped=true"
import script from "./PublicOptimizationDetail.vue?vue&type=script&lang=js"
export * from "./PublicOptimizationDetail.vue?vue&type=script&lang=js"

import "./PublicOptimizationDetail.vue?vue&type=style&index=0&id=1ec9fc4f&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./PublicOptimizationDetail.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec9fc4f"]])

export default __exports__